import React, { forwardRef } from 'react';

const LessonCanvas = forwardRef(function LessonCanvas(props, ref) {
  const { className = '', style, ...rest } = props;

  return (
    <canvas
      ref={ref}
      className={`lesson-canvas ${className}`}
      style={{
        display: 'block',
        ...style,
      }}
      {...rest}
    />
  );
});

export default LessonCanvas;
